export const LOAD_REVIEWS_REQUEST = 'SITTER_LOAD_REVIEWS_REQUEST';
export const LOAD_REVIEWS_SUCCESS = 'SITTER_LOAD_REVIEWS_SUCCESS';
export const LOAD_REVIEWS_FAILURE = 'SITTER_LOAD_REVIEWS_FAILURE';
